import * as React from "react";
// @ts-ignore TODO ts-ignore
import {HorizontalMenu, HorizontalMenuProps, HorizontalMenuRef} from "../HorizontalMenu";
import {GoodMapManager} from "./GoodMapManager";
// @ts-ignore TODO ts-ignore
import {ZapleczeHeader} from "../ZapleczeHeader";
import {MenuProps} from "../MenuConst.ts";
import {FC, JSX} from "react";
import Profile from "../Model/Profile.ts";
import {GoodFilterInterface} from "../Model/GoodFilter.ts";
import GoodMapToolbar, {GoodToolbarProps} from "./GoodMapToolbar.tsx";
import {GoodMapMenu} from "./GoodMapMenu.ts";

export interface ZapleczeGoodMapMenuProps {
    menuProps: MenuProps,
    menuRef: React.RefObject<HorizontalMenuRef | null>,
}
const ZapleczeGoodMapMenu:FC<ZapleczeGoodMapMenuProps> = (props): JSX.Element => {

    const thisProps: HorizontalMenuProps = {
        setMenuIx: props.menuProps.setMenuIx,
        isAdmin: props.menuProps.isAdmin,
        menuList: GoodMapMenu.arr,
        menuAdmin: GoodMapMenu.admin,
    };

    return (
        <HorizontalMenu {...thisProps} ref={props.menuRef}/>
    )
}

export interface ZapleczeGoodMapHeaderProps {
    menuProps: MenuProps,
    pageTitle: string,
    menuRef: React.RefObject<HorizontalMenuRef | null>,
}
export const ZapleczeGoodMapHeader:FC<ZapleczeGoodMapHeaderProps> = (props): JSX.Element => {
    const thisPops: ZapleczeGoodMapMenuProps = {
        menuProps: props.menuProps,
        menuRef: props.menuRef
    }
    return (
        <ZapleczeHeader pageTitle={props.pageTitle}>
            <ZapleczeGoodMapMenu {...thisPops}/>
        </ZapleczeHeader>
    );
}


export interface ZapleczeGoodMapToolbarProps extends GoodToolbarProps{ }
export const ZapleczeGoodMapToolbar:FC<ZapleczeGoodMapToolbarProps> = (props): JSX.Element => {
    return (
        <GoodMapToolbar {...props}/>
    );
}


export interface ZapleczeGoodMapPanelProps {
    profile: Profile,
    auth: {
        user:string,
        epid:string,
    }
    isAdmin: boolean,
    apiKey: string|null,
    openInProgress: boolean,
    setOpenInProgress: (open: boolean) => void,
    filter:GoodFilterInterface,
    setFilter: (filter:GoodFilterInterface) => void,
    filterReady: boolean,
    setFilterReady: (ready: boolean) => void,
    // ------------
    sessionId: string|null,
    lng: string|null,
    lat: string|null,
    city: string|null,
    cityId: string|null,
    // ------------
    // Komponent zależy od menuIx tylko w momencie wskazania go do narysowania i wymóg przekazania menuIx w props
    // jest wynikiem błędu w komponencie ZapleczeGoodMapMenu
    menuIx: number,
    setMenuIx: (index: number) => void,
    menuRef: React.RefObject<HorizontalMenuRef | null>,
}

export const ZapleczeGoodMapPanel:FC<ZapleczeGoodMapPanelProps> = (props): JSX.Element | null => {

    const goodMap = (): JSX.Element => {
        return <GoodMapManager {...props}/>
    }

    return (
        <>
        {goodMap()}
        </>
        // (props.menuIx === GoodMapMenu.ADD || props.menuIx === GoodMapMenu.MAIN) ? goodMap() : null
    );
}
